import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["Footer", "expander", "data", "className", "unclickableColumns", "customTdFunctions", "horizontallyScrollable"];
import React, { memo } from 'react';
import PropTypes from 'prop-types';
import ReactTable from 'react-table';
import createExpanded from "./service/createExpanded";
var AndesTable = function AndesTable(_ref) {
  var Footer = _ref.Footer,
    expander = _ref.expander,
    data = _ref.data,
    className = _ref.className,
    unclickableColumns = _ref.unclickableColumns,
    customTdFunctions = _ref.customTdFunctions,
    horizontallyScrollable = _ref.horizontallyScrollable,
    props = _objectWithoutProperties(_ref, _excluded);
  var expandedProps = expander !== null ? createExpanded(expander, data, unclickableColumns, customTdFunctions) : {};
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ReactTable, _extends({
    data: data,
    defaultPageSize: 10000,
    minRows: 0,
    showPagination: false,
    sortable: false,
    resizable: false,
    className: "andes-table ".concat(className, " ").concat(horizontallyScrollable && 'horizontally-scrollable')
  }, props, expandedProps)), Footer);
};
AndesTable.defaultProps = {
  Footer: null,
  expander: null,
  customTdFunctions: null,
  unclickableColumns: null,
  horizontallyScrollable: false,
  className: '',
  data: null
};
AndesTable.propTypes = {
  Footer: PropTypes.element,
  expander: PropTypes.func,
  customTdFunctions: PropTypes.arrayOf(PropTypes.func),
  unclickableColumns: PropTypes.arrayOf(PropTypes.string),
  horizontallyScrollable: PropTypes.bool,
  className: PropTypes.string,
  data: PropTypes.arrayOf(PropTypes.any)
};
export default /*#__PURE__*/memo(AndesTable);